import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useProjectHook } from '@/hooks/projectHook';
import Error from '@default/error';
import DetailSection from '@project/section_detail';

const Project = () => {
  const { state } = useLocation();
  const { title } = useParams();
  const projectHook = useProjectHook(state, title);

  return (
    projectHook.loadDone &&
    (projectHook.data ? (
      <DetailSection title={title} project={projectHook.data} />
    ) : (
      <Error />
    ))
  );
};

export default Project;
